import { CodedError } from '../CodedError';
import { errorCodeTypes } from './errorCodeTypes';

export class SaveUnitExternalReferencesFailedError extends CodedError {
  static get errorName() {
    return errorCodeTypes.saveUnitExternalReferencesFailedError.code;
  }

  constructor(
    message = errorCodeTypes.saveUnitExternalReferencesFailedError.message
  ) {
    super(message);
    this.code = errorCodeTypes.saveUnitExternalReferencesFailedError.code;
    this.message = `${message} ${errorCodeTypes.saveUnitExternalReferencesFailedError.code}`;
    this.name = errorCodeTypes.saveUnitExternalReferencesFailedError.name;
  }
}
